// extracted by mini-css-extract-plugin
export default {"image":"PasswordRecoverySuccessScreen_image__H+h-6","body":"PasswordRecoverySuccessScreen_body__eYseA"};